import { onUserToClientActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { UserForExternalActivityCard } from "./UserForExternalActivityCard";

interface Props {
  userToClientId: number
  config: server.dto.ActivityPanelConfig
}

export const UserForExternalActivityPanel = (props: Props) => {
  return <ActivityPanel<server.dto.UserToClientActivity>
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.UserForExternalAdmin.ListActivity({ itemId: props.userToClientId, page, perPage })}
    renderActivity={(activity => <UserForExternalActivityCard key={activity.activityId} activity={activity} />)}
    onActivityRegisterFn={onUserToClientActivity}
    onActivity={(activity) => {
      if (activity.itemId !== props.userToClientId) return { refreshActivities: false };

      const iAmActor = (activity.actor?.userId === site.currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}